import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

const url = process.env.REACT_APP_SERVER_URL
const api = new ExhibitionClient({url})


export const loadExhibit = createAsyncThunk('exhibit/loadExhibit', async (exhibitId) => {
  return api.exhibit().getById(exhibitId)
})


export const exhibitSlice = createSlice({
  name: 'exhibit',
  initialState: {
    exhibit: {},
  },
  extraReducers: {
    [loadExhibit.pending]: (state, _) => {
      state.exhibit = {}
    },
    [loadExhibit.fulfilled]: (state, action) => {
      const exhibit = action.payload
      state.exhibit = exhibit
    }
}})


export const selectExhibit = state => state.exhibit.exhibit

export default exhibitSlice.reducer
